// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/employees/{employeeId}/bank-accounts",
  Create: "/pyr/employees/{employeeId}/bank-accounts",
  Update: "/pyr/employees/{employeeId}/bank-accounts",
  Detail: "/pyr/employees/{employeeId}/bank-accounts",
};
